<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="panel panel-default">
          <div class="panel-heading"
            ><span style="font-size: 1.6em"
              >Guia {{ guia.autorizacao.numeroGuia }}</span
            ></div
          >
          <div class="panel-body">
            <form name="consulta">
              <div class="row">
                <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                  <label for="beneficiario">Beneficiário</label>
                  <input
                    id="beneficiario"
                    v-model="guia.beneficiario.nome"
                    data-test-id="input-beneficiario"
                    type="text"
                    name="beneficiario"
                    class="form-control"
                    readonly
                  />
                </div>
                <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                  <label for="convenio">Convênio</label>
                  <input
                    id="convenio"
                    v-model="guia.beneficiario.convenio.nome"
                    data-test-id="input-convenio"
                    type="text"
                    class="form-control"
                    name="convenio"
                    readonly
                  />
                </div>
                <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                  <label for="solicitante">Solicitante</label>
                  <input
                    id="solicitante"
                    v-model="
                      guia.contratadoSolicitante.profissionalSolicitante.nome
                    "
                    data-test-id="input-solicitante"
                    type="text"
                    class="form-control"
                    name="solicitante"
                    readonly
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="row text-center">
      <div class="col-xs-12 col-sm-12 col-md-10 col-lg-10">
        <Pagination
          v-if="total"
          v-model="pagina"
          :total-page="total"
          boundary-links
          @change="paginaAlterada"
        />
      </div>
      <div
        class="hidden-xs hidden-sm col-xs-2 col-sm-2 col-md-2 col-lg-2"
        style="margin: 17px 0"
      >
        <ToolbarModoResultado
          :modo-resultado="modoResultado"
          @modoAlterado="modoAlterado"
        />
      </div>
    </div>
    <div v-if="!total" id="resultadoNenhum" class="well">
      Nenhum resultado.
    </div>
    <div v-if="modoResultado === 'T' && total" id="resultadoTabela" class="row">
      <GuiaAgendamentosTabela
        :agendamentos="agendamentos"
        @agendamentoBloquearPagamento="bloquearPagamento"
        @agendamentoDesbloquearPagamento="desbloquearPagamento"
        @agendamentoRemover="removerAgendamento"
      />
    </div>
    <div v-if="modoResultado === 'C' && total" id="resultadoFicha" class="row">
      <div
        v-for="agendamento in agendamentos"
        :key="agendamento._id"
        class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
      >
        <GuiaAgendamentosFicha
          :agendamento="agendamento"
          @agendamentoBloquearPagamento="bloquearPagamento"
          @agendamentoDesbloquearPagamento="desbloquearPagamento"
          @agendamentoRemover="removerAgendamento"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import ToolbarModoResultado from '@/componentes/ToolbarModoResultado'
import { useMenu } from '@/composables/useMenu'
import { usePesquisa } from '@/composables/usePesquisa'
import AgendamentoServico from '@/servicos/AgendamentoServico'
import GuiaServico from '@/servicos/GuiaServico'

import GuiaAgendamentosFicha from './GuiaAgendamentosFicha'
import GuiaAgendamentosTabela from './GuiaAgendamentosTabela'

const menuAtual = {
  descricao: 'Agendamentos da Guia',
  breadcrumb: [
    'Atendimento',
    'Guia SP/SADT',
    'Consultar guia',
    'Agendamentos da guia',
  ],
}

export default {
  components: {
    GuiaAgendamentosFicha,
    GuiaAgendamentosTabela,
    ToolbarModoResultado,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const agendamentos = ref([])
    const guia = ref({
      autorizacao: { numeroguia: '' },
      beneficiario: { nome: '', convenio: { nome: '' } },
      contratadoSolicitante: { profissionalSolicitante: { nome: '' } },
    })
    const servico = new GuiaServico()
    const agendamentoServico = new AgendamentoServico()
    const nomeResultado = 'agendamentos'
    const filtro = ref({ guiaId: '' })
    const pesquisa = usePesquisa({
      filtro,
      resultado: agendamentos,
      servico,
      nomeResultado,
      recuperarTotal: (filtroAtual) =>
        servico.recuperarAgendamentosTotal(filtroAtual),
      recuperarTodos: (filtroAtual) =>
        servico.recuperarAgendamentos(filtroAtual),
      onNovo: () => router.replace({ path: route.path + '/cadastro' }),
    })
    useMenu(menuAtual)
    return {
      agendamentos,
      guia,
      servico,
      agendamentoServico,
      filtro,
      ...pesquisa,
    }
  },

  created() {
    this.recuperarGuia()
  },
  methods: {
    recuperarTotal() {
      return this.servico.recuperarAgendamentosTotal(this.filtro)
    },
    recuperarTodos() {
      return this.servico.recuperarAgendamentos(this.filtro)
    },
    recuperarGuia() {
      if (this.$route.params.guiaId) {
        const guiaId = this.$route.params.guiaId
        this.filtro.guiaId = guiaId
        this.servico.recuperar(guiaId).then((result) => {
          this.guia = result.guia
        })
      }
    },
    bloquearPagamento(agendamentoId) {
      this.agendamentoServico.bloquearPagamento(agendamentoId)
      this.pesquisar(this.filtro.skip)
    },
    desbloquearPagamento(agendamentoId) {
      this.agendamentoServico.desbloquearPagamento(agendamentoId)
      this.pesquisar(this.filtro.skip)
    },
    removerAgendamento(agendamentoId) {
      this.$confirm({
        title: 'Atenção',
        content: 'Deseja realmente remover esse agendamento?',
      }).then(async () => {
        await this.agendamentoServico.removerGuia(agendamentoId, this.guia._id)
        await this.agendamentoServico.remover(agendamentoId)
        this.pesquisar(this.filtro.skip)
      })
    },
  },
}
</script>
